
export default {
  reportLoading: () => {
    window.tntPhantomReportLoaded = false;
  },
  reportLoaded: () => {
    window.tntPhantomReportLoaded = true;
  },
};



// WEBPACK FOOTER //
// ./src/services/phantom/phantom.js